import React from "react";
import { getLocalStorage } from "@/helpers/common";
import { USER_INFO_KEY } from "@/constants/common";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";
import { useMLSAgentAtGitchaRedirect } from "@/hooks/useMLSAgentAtGitchaRedirect";
import { trackEvent } from "@/services/analytics";
import { pageURLs } from "@/constants/pageURLs";
import "./GitchaMemberBridge.scss";

const MARKETING_URL =
  process.env.REACT_APP_BLS_MARKETING_URL || "https://thebuyerlistingservice.com";

const GitchaMemberBridge = ({ slug, isSyndicated }) => {
  const { isGitchaDefaultWebsite } = useCurrentWebsite();
  const { redirectToBLSEnv, shouldRestrictAgent } =
    useMLSAgentAtGitchaRedirect();
  const sessionData = getLocalStorage(USER_INFO_KEY);
  const mls = sessionData?.userInfo?.mls;

  if (!isGitchaDefaultWebsite || !isSyndicated) return null;

  const isMember = shouldRestrictAgent && mls && mls !== "default";

  if (isMember) {
    return (
      <div className="gitcha-bridge gitcha-bridge--member">
        <p>
          You are a member of {mls.toUpperCase()}. Open this in your BLS to see
          matches and send an&nbsp;introduction.
        </p>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            trackEvent({
              name: "gitcha_member_bridge_clicked",
              attributes: { mls, slug },
            });
            redirectToBLSEnv({
              path: `${pageURLs.wantAdDetails}/${slug}`,
              onGitchaEnvFallback: null,
            });
          }}
        >
          Open in {mls.toUpperCase()}
        </button>
      </div>
    );
  }

  return (
    <p className="gitcha-bridge gitcha-bridge--prospect">
      Are you a real estate agent? Buyer demand like this lives in The Buyer
      Listing Service, inside your MLS or association.{" "}
      <a
        href={`${MARKETING_URL}/?utm_source=gitcha&utm_medium=referral&utm_campaign=member_bridge`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() =>
          trackEvent({
            name: "gitcha_bridge_marketing_clicked",
            attributes: { slug },
          })
        }
      >
        See if yours has&nbsp;it&nbsp;&rarr;
      </a>
    </p>
  );
};

export default GitchaMemberBridge;
